"use client"

import { useState } from "react"
import { useTranslations } from "next-intl"
import { PublicNavGlass } from "@/components/public-nav-glass"
import { ClientFooter } from "@/components/client/client-footer"
import { WaitlistModal } from "@/components/waitlist-modal"
import { LegalDocumentBody, type LegalDocument } from "@/components/legal/legal-document"

// The text lives in messages/pages/terms.{en,es}.json and renders through the
// shared legal renderer. It used to be hardcoded English in this file, so
// /es/terms served English — on the one page where a user is agreeing to
// something. Section ids are carried in the dictionary so existing anchors
// (notably /terms#refunds, linked from the refund policy) keep working.
export default function TermsPage() {
  const [waitlistOpen, setWaitlistOpen] = useState(false)
  const t = useTranslations("pages.terms")
  const doc = {
    title: t("title"),
    lastUpdated: t("lastUpdated"),
    // Present only in a translated dictionary; English is the governing text.
    translationNote: t.has("translationNote") ? t("translationNote") : undefined,
    sections: t.raw("sections"),
  } as LegalDocument

  return (
    <div className="min-h-screen bg-background md:pt-14">
      <PublicNavGlass defaultMode="light" showModeToggle={false} />
      <WaitlistModal open={waitlistOpen} onOpenChange={setWaitlistOpen} />

      <main className="max-w-3xl mx-auto px-4 pt-24 pb-12 md:pt-12">
        <LegalDocumentBody doc={doc} />
      </main>

      <ClientFooter />
    </div>
  )
}
